/**
 * SkipLink.tsx
 *
 * Componente skip-to-content per accessibilità da tastiera.
 * Deve essere il PRIMO elemento renderizzato nell'app (prima di <nav>).
 *
 * Utilizzo:
 *   In App.tsx / layout root:
 *   <SkipLink />
 *   <main id="main-content" tabIndex={-1}> ... </main>
 *
 * Il link è visibile SOLO quando riceve focus da tastiera (Tab).
 * Design coerente con il teal del design system (#4f98a3).
 */
import React from "react";

const SkipLink: React.FC = () => (
  <a
    href="#main-content"
    className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:rounded-lg focus:bg-[#4f98a3] focus:px-4 focus:py-2 focus:text-white focus:font-semibold"
  >
    Vai al contenuto principale
  </a>
);

export default SkipLink;
